import React, { useEffect, useState, Fragment } from 'react';
import styled from 'styled-components';
import { withLocalize } from 'react-localize-redux';
import { withRouter, Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { compose } from 'recompose';
import { acceptPolicy } from '../actions';


const Policy = (props) => {
  const { user, translate } = props;
  const isAccepted = get(user, 'isPolicyAccepted');
  const [fixToBottom, setFixToBottom] = useState(false);
  const [isShow, setIsShow] = useState(true);

  useEffect(() => {
    const { pathname } = props.location;
    if (pathname === '/' || pathname.includes('/admin') || pathname.includes('/event') || pathname.includes('/u') ) {
      setFixToBottom(true);
    } else {
      setFixToBottom(false);
    }
  });

  const handleClick = () => {
    props.acceptPolicy();
  };


  return (
    <Container
      isVisible={!isAccepted} fixToBottom={fixToBottom} isShow={isShow}
      onClick={() => setIsShow(!isShow)}
    >
      {
        isShow ? (
          <Fragment>
            <Icon name='angle down' size='large' />
            <Message>
              {translate('acceptPolicyMessage')} <Link to='/signup_policy'>{translate('termsOfService')}</Link>
            </Message>
            <Button data-cy-test-id='acceptCookieBtn' onClick={handleClick}>
              {translate('button.acceptPolicy')}
            </Button>
          </Fragment>
        ) : (
          <HiddenMessage>
            <Icon name='angle up' size='large'/>
            <span>{translate('shortAcceptPolicyMessage')}.</span>
          </HiddenMessage>
        )
      }
    </Container>
  );
};

const Container = styled.div`
    display: ${(props) => (props.isVisible ? 'flex' : 'none')}
    flex-direction: column;
    align-items:flex-start;
    justify-content:center;
    box-shadow: 0px 10px 60px rgba(0, 0, 0, 0.06);
    width: 100%;
    background: ${(props) => (props.isShow ? '#fff' : 'linear-gradient(160deg, #7340c4, #318edf)')};
    height: ${(props) => (props.isShow ? 'auto' : '30px')};
    padding: 10px 0 10px 10%;
    z-index: 1000;
    position: ${(props) => (props.fixToBottom ? 'fixed' : 'sticky')};
    bottom: 0;
    left: 0;
    transition: height 2s linear;
    cursor: pointer;

    i {
      transform: translateX(-200%);
      cursor: pointer;
    }

    @media (max-width: 540px) {
      i {
        transform: translateX(-50%);
      }
  }
   @media (max-width: 430px) {
     height: ${(props) => (props.isShow ? 'auto' : '40px')};
  }
`;
const Message = styled.p`
   width: 60%;
   margin-bottom: 10px;
   font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
   color: rgba(0,0,0,.85);
   font-size: 12px;

   @media (max-width: 886px) {
    width: 80%;
  }
`;

const HiddenMessage = styled.div`
  font-family: Lato,'Helvetica Neue',Arial,Helvetica,  sans-serif;
  color: rgba(0,0,0,.85);
  font-size: 12px;
  color: #fff;

 i {
   transform: translateX(-100%);
   color: #fff;
 }

  @media (max-width: 540px) {
    width: 80%;

      i {
        transform: translateX(0%);
      }
  }
`;


const Button = styled.button`
    width: 150px;
    width: fit-content;
    color: white;
    background: linear-gradient(160deg, #7340c4, #318edf);
    border: none;
    font-size: 12px;
    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif;
    letter-spacing: 0.1em;
    transition: all 0.2s ease-in-out 0s;
    opacity: 0.9;
    border-radius: 0.286rem;
    padding: 0.86rem 1.71rem;
    margin-right: 0;
    box-shadow: 0 0.1875rem 0.375rem rgb(27 99 169 / 10%), 0 0.1875rem 0.375rem rgb(27 99 169 / 20%);
    border: none;
    color: #fff;
    cursor: pointer;

    @media (max-width: 886px) {
    padding: 0.4rem 0.8rem;
    margin-top: 10px;
   }
`;

export default compose(
  withRouter,
  withLocalize,
  connect(
    ({ user }) => ({ user }),
    { acceptPolicy }
  ),
)(Policy);



// WEBPACK FOOTER //
// ./src/components/common/policy.js